export function OnboardingJourneySvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/onboarding-journey.svg'"></ng-include>`
    }
}